import { createResponsiveStateReducer } from "redux-responsive"

import accountReducer from "areas/account/store/reducers"
import cartUiReducer from "areas/cart/store/cart-ui-reducer"
import cartReducer from "areas/cart/store/reducers"
import checkoutReducer from "areas/checkout/store/reducers"
import collectionReducer from "areas/collection/store/reducers"
import {
  boxDesigns,
  panel,
  choices,
  diamondSelector,
  diamondUI,
  previewImage,
  previewImageUI,
  wizard,
  wizardUI,
  display,
  halfModal,
} from "areas/product/store/reducers"

import { alerts, experiment, menu, messages, sale, user } from "./app/reducers"
import headerReducer from "./header/reducers"
import searchReducer from "./search/reducers"
import shareReducer from "./share/reducers"
import wishlistReducer from "./wishlist/reducers"

const appReducers = {
  account: accountReducer,
  alerts,
  boxDesigns,
  browser: createResponsiveStateReducer({
    desktop: 9999,
    mobile: 767,
    tablet: 1023,
  }),
  cart: cartReducer,
  cartUI: cartUiReducer,
  checkout: checkoutReducer,
  choices,
  collection: collectionReducer,
  diamondSelector,
  diamondUI,
  display,
  experiment,
  halfModal,
  header: headerReducer,
  menu,
  messages,
  panel,
  previewImage,
  previewImageUI,
  sale,
  search: searchReducer,
  share: shareReducer,
  user,
  wishlist: wishlistReducer,
  wizard,
  wizardUI,
}

export default appReducers
